import { getAuthToken } from '@dynamic-labs/sdk-react-core';
import axios from 'axios';

const API_BASE_URL = process.env.NEXT_PUBLIC_API_BASE_URL;

const instance = axios.create({
  baseURL: API_BASE_URL,
  timeout: 15000,
  withCredentials: true,
});

instance.interceptors.request.use(async (config) => {
  const token = getAuthToken();

  config.headers = config.headers ?? {};

  if (token) {
    config.headers.Authorization = config.headers.Authorization ?? `Bearer ${token}`;
  }

  return config;
});

export default instance;
